export const SIDEBAR_BROWSER_DRAG_GUARD_EVENTS = [
  'dragenter',
  'dragover',
  'drop',
] as const;

export const SIDEBAR_BROWSER_DRAG_GUARD_EXTERNAL_TYPES = [
  'text/uri-list',
  'text/plain',
  'text/html',
] as const;

let activeSidebarDragGuards = 0;
let sidebarDragRevealFrame: number | null = null;

export function scrubSidebarBrowserDragTransfer(
  dataTransfer: DataTransfer | null
) {
  if (!dataTransfer) {
    return;
  }

  try {
    dataTransfer.effectAllowed = 'move';
    dataTransfer.dropEffect = 'move';
  } catch {
    // Browser-owned drag stores can reject writes outside dragstart.
  }

  for (const type of SIDEBAR_BROWSER_DRAG_GUARD_EXTERNAL_TYPES) {
    try {
      dataTransfer.setData(type, '');
    } catch {
      // Browser-owned drag stores can reject writes outside dragstart.
    }
  }
}

export function enableSidebarBrowserDragGuard() {
  activeSidebarDragGuards += 1;
  if (activeSidebarDragGuards === 1) {
    sidebarDragRevealFrame = requestAnimationFrame(() => {
      sidebarDragRevealFrame = null;
      if (activeSidebarDragGuards > 0) {
        document.documentElement.dataset.sidebarDragging = 'true';
      }
    });
  }

  const preventBrowserSidebarDragDefault = (event: DragEvent) => {
    event.preventDefault();
    scrubSidebarBrowserDragTransfer(event.dataTransfer);
  };

  SIDEBAR_BROWSER_DRAG_GUARD_EVENTS.forEach(eventName => {
    window.addEventListener(eventName, preventBrowserSidebarDragDefault, {
      capture: true,
    });
    document.addEventListener(eventName, preventBrowserSidebarDragDefault, {
      capture: true,
    });
  });

  let released = false;
  return () => {
    if (released) {
      return;
    }
    released = true;

    SIDEBAR_BROWSER_DRAG_GUARD_EVENTS.forEach(eventName => {
      window.removeEventListener(eventName, preventBrowserSidebarDragDefault, {
        capture: true,
      });
      document.removeEventListener(
        eventName,
        preventBrowserSidebarDragDefault,
        {
          capture: true,
        }
      );
    });

    activeSidebarDragGuards = Math.max(0, activeSidebarDragGuards - 1);
    if (activeSidebarDragGuards === 0) {
      if (sidebarDragRevealFrame !== null) {
        cancelAnimationFrame(sidebarDragRevealFrame);
        sidebarDragRevealFrame = null;
      }
      delete document.documentElement.dataset.sidebarDragging;
    }
  };
}
